import React from "react";
// import { useDrag } from "react-dnd";

export const PetCard = ({ id, text, code, type, pindex, mode, addItem }) => {
  // const [{ isDragging }, dragRef] = useDrag({
  //   type: "pet",
  //   item: { id, text, code, type, pindex, mode },
  //   collect: (monitor) => ({
  //     isDragging: monitor.isDragging(),
  //   }),
  // });
  const petColor = (mode) => {
    let color = "#a6a6a6";
    switch (mode) {
      case "user":
        color = "#f59090";
        break;
      case "title":
        color = "#49f56c";
        break;
      case "text":
        color = "#49f56c";
        break;
      default:
        color = "#a6a6a6";
    }
    return color;
  };
  return (
    <div
      style={{
        cursor: "pointer",
        minWidth: 20,
        paddingRight: 2,
        paddingLeft: 2,
        height: 25,
        backgroundColor: petColor(mode ? mode : type),
        margin: 2,
        borderRadius: 3,
        textAlign: "center",
        color: "#FFF",
        fontSize: 13,
      }}
      // ref={dragRef}
      onClick={() => {
        addItem({
          id,
          text,
          code,
          type,
          pindex,
          mode,
        });
      }}
    >
      {text}

      {/* {isDragging && "😱"} */}
    </div>
  );
};
